import React from 'react'
import PdaTitle from '../../component/common/PdaTitle'
import LogoDark from '../../component/common/LogoDark'
import { PdaMenuItem } from '../../types/common'
import MenuLink from '../../component/common/MenuLink'
import { tokens } from '../../locales/tokens'
import { useTranslation } from 'react-i18next'

const InventoryMenu = () => {
    const { t } = useTranslation()
    const menus: PdaMenuItem[] = [
        {
            name: t(tokens.inventory.inventory_inquiry),
            uri: '/inventory-list',
        },
        {
            name: t(tokens.inventory.inventory_replenishment),
            uri: '/inventory-supplement',
        },
        {
            name: t(tokens.common.inventory_investigation),
            uri: '/inventory-survey',
        },
        {
            name: t(tokens.inventory.register_location),
            uri: '/location-regist',
        },
    ]

    return (
        <>
            <PdaTitle title={t(tokens.inventory.inventory_management)} historyBack />
            <LogoDark />
            <MenuLink items={menus} color="bg-color-yellow border-color-yellow" />
        </>
    )
}

export default InventoryMenu
